/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerJoinRequestDto } from '../../models/partner-join-request-dto';

export interface PartnerJoinRequestControllerCancelJoinRequest$Params {

/**
 * 가입 요청 ID
 */
  id: string;
}

export function partnerJoinRequestControllerCancelJoinRequest(http: HttpClient, rootUrl: string, params: PartnerJoinRequestControllerCancelJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerJoinRequestDto>> {
  const rb = new RequestBuilder(rootUrl, partnerJoinRequestControllerCancelJoinRequest.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerJoinRequestDto>;
    })
  );
}

partnerJoinRequestControllerCancelJoinRequest.PATH = '/api/partner-join-request/join/{id}/cancel';
